import React from 'react';
import FeatureCard from './FeatureCard';

const FeatureCards = () => {
  const features = [
    {
      icon: 'fas fa-shield-virus',
      title: 'Safety First',
      description: 'Strict sterilization protocols prioritizing your health.',
    },
    {
      icon: 'fas fa-user-md',
      title: 'Expert Care',
      description: 'Led by Dr. Lakruwan Wijayasinghe, a leading dental surgeon in Kottawa.',
    },
    {
      icon: 'fas fa-magic',
      title: 'Advanced Tech',
      description: 'State-of-the-art equipment for precise comfortable treatments.',
    }
  ];

  return (
    <section className="relative mt-12 md:-mt-20 z-20 mb-20">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;
